<template>
  <div>
    <div class="panel panel-default">
      <div class="panel-body panel-body--padding">
        <filters
          :form="businessRuleGroup"
          :disabled-form="isEditOperation"
          @form-field-changed="updateMainForm(businessRuleGroup, $event)"
        />
      </div>

      <div class="panel-body panel-body--padding">
        <recipients
          v-if="queroPagoRecipientLoaded"
          :split-rule-form="splitRule"
          :qp-split-rule-form="queropagoSplitRule"
          :selected-recipient="recipient"
          :disabled-form="isEditOperation"
          @update-recipient="setSelectedRecipient"
          @split-rule-form-field-changed="updateMainForm(splitRule, $event)"
          @qp-split-rule-form-field-changed="updateMainForm(queropagoSplitRule, $event)"
        />
      </div>

      <div class="row">
        <div class="col-md-8 col-md-offset-2">
          <div class="panel-body panel-body--padding">
            <div class="panel panel-default">
              <div class="panel-heading">
                <label class="control-label">Cobrança</label>
              </div>
              <div class="panel-body panel-body--padding">
                <div class="row">
                  <div class="col-md-10 col-md-offset-1">
                    <table class="table table-bordered ">
                      <colgroup>
                        <col class="col-md-5">
                        <col class="col-md-5">
                      </colgroup>
                      <tbody>
                        <due-day-rule
                          :form="dueDayRule"
                          :disabled-form="isEditOperation"
                          @form-field-changed="updateMainForm(dueDayRule, $event)"
                        />
                        <payment-method-rules
                          :form="paymentMethodRules"
                          @form-field-changed="updateMainForm(paymentMethodRules, $event)"
                        />
                        <contract-discharge-rules
                          :form="contractDischargeRules"
                          @form-field-changed="updateMainForm(contractDischargeRules, $event)"
                        />
                        <contract-creation-rule
                          :form="contractCreationRule"
                          @form-field-changed="updateMainForm(contractCreationRule, $event)"
                        />
                        <charges-rule
                          :form="chargesRule"
                          @form-field-changed="updateMainForm(chargesRule, $event)"
                        />
                        <qb-integration-rule
                          :form="qbIntegrationRule"
                          @form-field-changed="updateMainForm(qbIntegrationRule, $event)"
                        />
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="panel-body panel-body--padding">
            <admission-payment-rule
              :form="admissionPaymentRule"
              @form-field-changed="updateMainForm(admissionPaymentRule, $event)"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="panel-body panel-body--padding">
            <bill-adjustment-rules
              :underpaymentForm="underpaymentRule"
              :overpaymentForm="overpaymentRule"
              @underpayment-form-field-changed="updateMainForm(underpaymentRule, $event)"
              @overpayment-form-field-changed="updateMainForm(overpaymentRule, $event)"
            />
          </div>
        </div>
      </div>

      <div class="panel-body panel-body--padding">
        <div class="panel panel-default">
          <div class="panel-heading">
            <label class="control-label">Desconto de pontualidade</label>
          </div>
          <div class="panel-body panel-body--padding">
            <advanced-payment-discount-modal
              v-if="showAdvancedPaymentDiscountModal"
              @close="changeModalVisibility('showAdvancedPaymentDiscountModal', false)"
              @advanced-payment-discount-created="createAdvancedPaymentDiscount"
            />
            <table class="table table-striped table-bordered">
              <thead>
                <tr>
                  <th>
                    Referência
                    <span
                      class="icon--micro glyphicon glyphicon-info-sign"
                      data-toggle="tooltip"
                      title="Define se a regra conta dias a partir do início do mês ou
                      de vencimento da mensalidade."
                    >
                    </span>
                  </th>
                  <th>
                    Contagem
                    <span
                      class="icon--micro glyphicon glyphicon-info-sign"
                      data-toggle="tooltip"
                      title="Define se a regra deve considerar dias úteis ou dias corridos."
                    >
                    </span>
                  </th>
                  <th>Dias de carência</th>
                  <th>
                    Desconto
                  </th>
                  <th>Base de cálculo</th>
                  <th>
                    Retroativo
                    <span
                      class="icon--micro glyphicon glyphicon-info-sign"
                      data-toggle="tooltip"
                      title="Define se a regra será aplicada a todas as mensalidades passadas, ou seja,
                      criadas antes dessa regra ser ativada."
                    >
                    </span>
                  </th>
                  <th>
                    Ações
                  </th>
                </tr>
              </thead>
              <tbody>
                <template v-if="advancedPaymentDiscountRules.create.length">
                  <tr v-for="(discount, index) in advancedPaymentDiscountRules.create">
                    <td>{{ discount.translatedDaysRelativeTo }}</td>
                    <td>{{ discount.translatedDaysKind }}</td>
                    <td>{{ discount.days }}</td>
                    <td>
                      {{ formatAmountType(discount.amountType, discount.treatedAmountValue) }}
                    </td>
                    <td v-if="discount.stackDiscounts">
                      Valor com desconto
                    </td>
                    <td v-else>
                      Valor cheio
                    </td>
                    <td>{{ discount.retroactive | formatBoolean }}</td>
                    <td class="table-centralized">
                      <button
                        class="btn btn-danger"
                        title="Desabilitar desconto de pontualidade"
                        @click.prevent="disableAdvancedPaymentDiscountRule(index)"
                      >
                        <i class="fas fa-times"></i>
                      </button>
                    </td>
                  </tr>
                </template>
                <template v-else>
                  <tr>
                    <td colspan="7">
                      <p class="text-center">
                        Sem desconto de pontualidade
                      </p>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
            <button
              class="btn btn-primary"
              title="Selecionar recebedor"
              @click.prevent="changeModalVisibility('showAdvancedPaymentDiscountModal', true)"
            >
              <div>
                <i class="fas fa-plus"></i>
                Criar desconto
              </div>
            </button>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button
          v-if="!isEditOperation"
          class="btn btn-lg btn-primary"
          v-permissions:configuration_business_rule_group.create
          @click.prevent="createOrUpdate"
        >
          Salvar
        </button>
        <button
          v-if="isEditOperation"
          class="btn btn-lg btn-primary"
          v-permissions:configuration_business_rule_group.update
          @click.prevent="createOrUpdate"
        >
          Editar
        </button>
        <button
          class="btn btn-lg btn-default"
          @click="$emit('edit-business-rule-group', false)"
        >
          Voltar
        </button>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
  @import 'assets/stylesheets/utils/_spacing.sass';

  .panel-body--padding {
    padding: $space-m $space-st $space-xxs $space-st;
  }
</style>
<script>
import Permissions from 'mixins/Permissions';
import AdvancedPaymentDiscountModal from './components/AdvancedPaymentDiscountModal';
import AdmissionPaymentRule from './components/AdmissionPaymentRule';
import BillAdjustmentRules from './components/BillAdjustmentRules';
import ContractDischargeRules from './components/ContractDischargeRules';
import ContractCreationRule from './components/ContractCreationRule';
import ChargesRule from './components/ChargesRule';
import DueDayRule from './components/DueDayRule';
import Filters from './components/Filters';
import Computeds from './utils/computeds';
import Forms from './utils/forms';
import Methods from './utils/methods';
import PaymentMethodRules from './components/PaymentMethodRules';
import QbIntegrationRule from './components/QbIntegrationRule';
import Recipients from './components/Recipients';

export default {
  mixins: [Permissions],
  components: {
    AdvancedPaymentDiscountModal,
    AdmissionPaymentRule,
    BillAdjustmentRules,
    ContractDischargeRules,
    ContractCreationRule,
    ChargesRule,
    DueDayRule,
    Filters,
    PaymentMethodRules,
    QbIntegrationRule,
    Recipients,
  },
  props: {
    rule: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      ...Forms.include(),
      showAdvancedPaymentDiscountModal: false,
      queroPagoRecipientLoaded: false,
      recipient: null,
      defaultChargesRule: {
        interestRate: '1.00',
        penaltyRate: '2.00',
        chargesBasedOn: 'full_amount',
        applyCharges: true,
      },
    };
  },
  computed: {
    ...Computeds.include,
  },
  methods: {
    ...Methods.include,
  },
  created() {
    this.$loader.show();

    this.loadQueroPagoRecipient()
      .then(() => {
        this.queroPagoRecipientLoaded = true;
      })
      .catch(() => {
        this.queroPagoRecipientLoaded = false;
        this.$alert.notifyAlert('Erro ao carregar recebedor do Quero Pago');
      })
      .finally(() => {
        if (this.isEditOperation) {
          this.loadSplitRules();
        }
        this.queropagoSplitRule.addValues({ recipientId: this.queroPagoRecipient.id });
        this.$loader.hide();
      });
  },
  mounted() {
    this.loadRecipients(this.institution.id);
    this.initializeTooltips();
    this.businessRuleGroup.addValues({ institutionId: this.institution.id });
    this.chargesRule.addValues({ ...this.defaultChargesRule });

    if (this.isEditOperation) {
      this.loadBusinessRuleGroup();
      this.loadDueDayRule();
      this.loadPaymentMethodsRules();
      this.loadContractDischargeRules();
      this.loadContractCreationRule();
      this.loadChargesRule();
      this.loadQbIntegrationRule();
      this.loadAdmissionPaymentRule();
      this.loadBillAdjustmentRule(this.underpaymentRule, this.rule.underpaymentBillAdjustmentRule);
      this.loadBillAdjustmentRule(this.overpaymentRule, this.rule.overpaymentBillAdjustmentRule);
      this.loadAdvancedDiscountPaymentRule();
    }
  },
};

</script>
